import { render, staticRenderFns } from "./Ideas.vue?vue&type=template&id=3c2c8043&"
import script from "./Ideas.vue?vue&type=script&lang=js&"
export * from "./Ideas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports